import { render, staticRenderFns } from "./ApprovalRequest.vue?vue&type=template&id=c10ddf16&scoped=true"
import script from "./ApprovalRequest.vue?vue&type=script&lang=js"
export * from "./ApprovalRequest.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRequest.vue?vue&type=style&index=0&id=c10ddf16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10ddf16",
  null
  
)

export default component.exports